import { useState, useEffect, useCallback } from 'react';

import './YunEmFineTune.css';
import { debounce, openWindow } from '../../../utils/index';
import YunIcon from '../YunIcon/YunIcon'

import {
    updateLocalDbEmRate,
    updateLocalDbEmHumanize,
    updateLocalDbEmFlex,
    updateLocalDbEmVibrato,
    updateLocalDbEmTracking,
    updateEmValue,
} from '../../../utils/dbHandle';
import {
    setUpdateRateValue,
    setUpdateHumanizeValue,
    setUpdateFlexValue,
    setUpdateVibratoValue,
    setUpdateTrackingValue,
    setUpdateInputType,
    setUpdateEmValues,
    getEmValueByLinkage,
} from '../../App/tools';

import {
    EmValueRange,
} from '../../App/data';

import {
    cppRemoteClearParamsCache,
} from '../../../api/cpp';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Slider from '@material-ui/core/Slider';

import YunEmRate from '../YunEmRate/YunEmRate';
import YunEmFlex from '../YunEmFlex/YunEmFlex';
import YunEmVibrato from '../YunEmVibrato/YunEmVibrato';
import YunEmTracking from '../YunEmTracking/YunEmTracking';
import YunEmHumanize from '../YunEmHumanize/YunEmHumanize';
import YunSection from '../YunSection/YunSection';

import {
    sliderConfig,
    getShortcutLinkNames,
    getLinkageNames,
} from './tool';

const d_setUpdateRateValue = debounce(setUpdateRateValue, 200);
const d_setUpdateHumanizeValue = debounce(setUpdateHumanizeValue, 200);
const d_setUpdateFlexValue = debounce(setUpdateFlexValue, 200);
const d_setUpdateVibratoValue = debounce(setUpdateVibratoValue, 200);
const d_setUpdateTrackingValue = debounce(setUpdateTrackingValue, 200);
const d_setUpdateEmValues = debounce(setUpdateEmValues, 500);

const d_updateLocalDbEmRate = debounce(updateLocalDbEmRate, 500);
const d_updateLocalDbEmHumanize = debounce(updateLocalDbEmHumanize, 600);
const d_updateLocalDbEmFlex = debounce(updateLocalDbEmFlex, 700);
const d_updateLocalDbEmVibrato = debounce(updateLocalDbEmVibrato, 800);
const d_updateLocalDbEmTracking = debounce(updateLocalDbEmTracking, 900);
const d_updateEmValue = debounce(updateEmValue, 500);

const range = new EmValueRange();
let isInit = false;

const YunEmFineTune = function(props) {
    const {
        pageset,
        emPlugsV3,
        playerData,
        emValue,
        setEmValue,
        presetConfig,
        shortcutList,
        isSetShortcutByEmModel,
        pluginModel,
        setPluginModel,
        shortcutLink,
        currentShortcutName,
        setCurrentShortcutName,
        emPluginState,
        emLinkage,
        emModelNames,
    } = props;
    // 电音模式名称：后台可配，没传就用默认的中性叫法
    const modelNames = Object.assign(
        { soprano: '男/女高音', alto: '男/女中音', lowMale: '男/女低音' },
        emModelNames || {}
    );

    const [emLinkageVal, setEmLinkageVal] = useState(50);

    useEffect(() => {
        if (!pageset.emFineTune) {
            cppRemoteClearParamsCache()
        }
    }, [pageset]);

    useEffect(() => {
        if (emPluginState.length && pluginModel.name !== '默认' && !isInit) {
            isInit = true;
            setUpdateInputType(emPlugsV3, pluginModel.value);
        }
    }, [emPluginState, pluginModel, emPlugsV3]);

    // 设置电音模式
    const changePluginModel = (e, value) => {
        if (value.props && value.props.value) {
            setPluginModel({
                name: value.props.children,
                value: value.props.value,
            })
            setUpdateInputType(emPlugsV3, value.props.value);
        }
    }
    // 调整联动条件
    const handleEmLinkage = useCallback((val) => {
        setEmLinkageVal(val);
        const result = getEmValueByLinkage(val, emLinkage, range);
        const param = {};
        for (const key in result) {
            if (typeof result[key] === "number") {
                param[key] = result[key];
            }
        }
        setEmValue(param);
        d_setUpdateEmValues(emPlugsV3, param);
        d_updateEmValue(param, playerData);
    }, [emLinkage, emPlugsV3, setEmValue, playerData])
    // 选择预设电音强度
    const clickSelectStrength = (item) => {
        const param = {}
        if (shortcutLink.rate && item && typeof item.rate === "number") {
            param.rate = item.rate
        }
        if (shortcutLink.humanize && item && typeof item.humanize === "number" ) {
            param.humanize = item.humanize
        }
        if (shortcutLink.flex && item && typeof item.flex === "number") {
            param.flex = item.flex
        }
        if (shortcutLink.vibrato && item && typeof item.vibrato === "number") {
            param.vibrato = item.vibrato
        }
        if (shortcutLink.tracking && item && typeof item.tracking === "number") {
            param.tracking = item.tracking
        }
        setEmValue(param);
        setCurrentShortcutName(item.name);
        setUpdateEmValues(emPlugsV3, param);
        d_updateEmValue(param, playerData);
    }
    // 调整电音速率
    const handleEmRate = (val) => {
        if (val > 400) val = 400;
        if (val < 0) val = 0;
        setEmValue({
            rate: val
        })
        if (currentShortcutName) {
            setCurrentShortcutName("");
        }
        d_setUpdateRateValue(emPlugsV3, val);
        // 存储到本地数据库
        d_updateLocalDbEmRate(val, playerData);
    };
    // 调整电音拟人
    const handleEmHumanize = (val) => {
        if (val > sliderConfig.max) val = sliderConfig.max;
        if (val < sliderConfig.min) val = sliderConfig.min;
        setEmValue({
            humanize: val
        })
        if (currentShortcutName) {
            setCurrentShortcutName("");
        }
        d_setUpdateHumanizeValue(emPlugsV3, val);
        // 存储到本地数据库
        d_updateLocalDbEmHumanize(val, playerData);
    };
    // 调整电音弹性
    const handleEmFlex = (val) => {
        if (val > sliderConfig.max) val = sliderConfig.max;
        if (val < sliderConfig.min) val = sliderConfig.min;
        setEmValue({
            flex: val
        })
        if (currentShortcutName) {
            setCurrentShortcutName("");
        }
        d_setUpdateFlexValue(emPlugsV3, val);
        // 存储到本地数据库
        d_updateLocalDbEmFlex(val, playerData);
    };
    // 调整电音颤音
    const handleEmVibrato = (val) => {
        if (val > 12) val = 12;
        if (val < -12) val = -12;
        setEmValue({
            vibrato: val
        })
        if (currentShortcutName) {
            setCurrentShortcutName("");
        }
        d_setUpdateVibratoValue(emPlugsV3, val);
        // 存储到本地数据库
        d_updateLocalDbEmVibrato(val, playerData);
    };
    // 调整电音跟踪
    const handleEmTracking = (val) => {
        if (val > 100) val = 100;
        if (val < 1) val = 1;
        setEmValue({
            tracking: val
        })
        if (currentShortcutName) {
            setCurrentShortcutName("");
        }
        d_setUpdateTrackingValue(emPlugsV3, val);
        // 存储到本地数据库
        d_updateLocalDbEmTracking(val, playerData);
    };

    const clickToEmPage = (e, tabIndex) => {
        if (e.preventDefault) e.preventDefault()
        if (e.stopPropagation) e.stopPropagation()
        window.localStorage.setItem('sy_em_page_tab_index', tabIndex);
        setTimeout(() => {
            openWindow(`${window.location.origin}${window.location.pathname}#/em`);
        }, 500)
    }

    // if (!pageset.emFineTune) {
    //     return null;
    // }

    let emModelEditEle = null;
    if (isSetShortcutByEmModel) {
        const list = getShortcutLinkNames(shortcutLink)
        emModelEditEle = (
            <div className="LinkCnfLabel RateSelect">
                <div className="SubLabel HoverColor MainColor">关联配置</div>
                <Select value="">
                    <MenuItem onClick={(e) => clickToEmPage(e, '1')} className="SelectItem BorderBottom JustShow">关联项</MenuItem>
                    {
                        list.map((item, index) => (
                            <MenuItem onClick={(e) => clickToEmPage(e, '1')} className="SelectItem JustShow" key={'link-item-' + index}>{item}</MenuItem>
                        ))
                    }
                </Select>
            </div>
        )
    }
    //  电音模式
    let emModelEle = null;
    if (pageset.emModel) {
        emModelEle = (
            <div className="YunEmModel">
                <div className="YunEmModelSelect">
                    <div className="label">电音模式：</div>
                    <div className="YunSelect YunBtn MainColor2">
                        <div className="SelectLabel">
                            {pluginModel.name}
                        </div>
                        <YunIcon icon="expand"></YunIcon>
                        <Select value="" onChange={changePluginModel}>
                            <MenuItem className="SelectItem" value="soprano">{modelNames.soprano}</MenuItem>
                            <MenuItem className="SelectItem" value="alto">{modelNames.alto}</MenuItem>
                            <MenuItem className="SelectItem" value="lowMale">{modelNames.lowMale}</MenuItem>
                        </Select>
                    </div>
                </div>
                {emModelEditEle}
            </div>
        )
    }
    // 快捷选择
    let YunEmStrengthSelect = null;
    if ((pageset.shortcut && shortcutList.length)) {
        YunEmStrengthSelect = (
            <div className="YunEmStrengthSelect">
                { shortcutList.map((item, index) => (
                    <div key={index} onClick={() => clickSelectStrength(item)} className={currentShortcutName === item.name ? "YunBtn Active" : "YunBtn"}>{item.showName}</div>
                )) }
            </div>
        )
    }
    // 联动调节
    let emLinkageEle = null;
    if (pageset.emLinkage) {
        const linkageNames = getLinkageNames(emLinkage)
        emLinkageEle = (
            <div className="YunEmLinkage">
                <div className="YunEmLinkageWrapper">
                    <div className="Label">联调：</div>
                    <Slider value={emLinkageVal} onChange={(e, val) => handleEmLinkage(val)} />
                    <div className="RateSelect BottomLine IconRight MainColor HoverColor">
                        <div className="RateSelectLabel HoverColor MainColor">{emLinkageVal}</div>
                        <YunIcon iconClass="MainColor HoverColor" icon="expand"></YunIcon>
                        <Select value="">
                            <MenuItem onClick={(e) => clickToEmPage(e, '2')} className="SelectItem BorderBottom JustShow">关联项</MenuItem>
                            {
                                linkageNames.map((item, index) => (
                                    <MenuItem onClick={(e) => clickToEmPage(e, '2')} className="SelectItem JustShow" key={'link-item-' + index}>{item}</MenuItem>
                                ))
                            }
                        </Select>
                    </div>
                </div>
            </div>
        )
    }

    if (!pageset.emModel && !pageset.shortcut && !pageset.emLinkage && !pageset.emRate && !pageset.emHumanize && !pageset.emVibrato && !pageset.emFlex && !pageset.emTracking) {
        return null;
    }

    return (
        <div className="YunEmFineTune YunComponent">
            <YunSection width="200">
                {emModelEle}
                {emLinkageEle}
                {YunEmStrengthSelect}
                <YunEmRate
                    emRateVal={emValue.rate}
                    handleEmRate={handleEmRate}
                    ratePreset={presetConfig.ratePreset}
                    emRate={pageset.emRate}
                    >
                </YunEmRate>
                <YunEmHumanize
                    emHumanizeVal={emValue.humanize}
                    handleEmHumanize={handleEmHumanize}
                    humanizePreset={presetConfig.humanizePreset}
                    emHumanize={pageset.emHumanize}
                    >
                </YunEmHumanize>
                <YunEmVibrato
                    emVibratoVal={emValue.vibrato}
                    handleEmVibrato={handleEmVibrato}
                    vibratoPreset={presetConfig.vibratoPreset}
                    emVibrato={pageset.emVibrato}
                    >
                </YunEmVibrato>
                <YunEmFlex
                    emFlexVal={emValue.flex}
                    handleEmFlex={handleEmFlex}
                    flexPreset={presetConfig.flexPreset}
                    emFlex={pageset.emFlex}
                    >
                </YunEmFlex>
                <YunEmTracking
                    emTrackingVal={emValue.tracking}
                    handleEmTracking={handleEmTracking}
                    trackingPreset={presetConfig.trackingPreset}
                    emTracking={pageset.emTracking}
                    >
                </YunEmTracking>
           </YunSection>
        </div>
    )
}

export default YunEmFineTune;
